export default {
  async fetchUsers({ commit }, payload) {
    if (!payload.query || payload.query === '') {
      return;
    }
    const params = new URLSearchParams({
      search: payload.query,
      limit: payload.limit,
      autocomplete: payload.autocomplete,
    }).toString();
    if (params !== '') {
      let response = await fetch(`/api/users?${params}`);
      let data = await response.json();
      commit('setUsersData', data);
      return data;
    }
  },
  async getUserReputationScores({ commit }, userId) {
    const data = await fetch(
      `/api/metric/pull/json/user/filldate,%3CreputationCategoryId/rating:avg?where={kind:reputation_score,userId:${userId}}&days=30&fill=filldate:day`,
    );
    const result = await data.json();
    commit('setUserReputationScores', result);
    return result;
  },
};
